import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-emit-on-dirty]';
export const PLUGIN_NAME = 'EmitOnDirty';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--emit-on-dirty" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__emit-on-dirty/index.js